import React, { useEffect, useState } from 'react';
import { subscribe } from '../utils/loaderBus';
import BrandLoader from './BrandLoader';
import './GlobalLoader.css';

// Shows the logo loader in a floating badge whenever one or more API
// calls made through utils/api.js are in flight. Mounted once in App.js —
// pages no longer need their own spinners just for background API activity.
const GlobalLoader = () => {
    const [pending, setPending] = useState(0);

    useEffect(() => subscribe(setPending), []);

    if (pending === 0) return null;

    return (
        <div className="global-loader-overlay" role="status" aria-live="polite" aria-label="Loading">
            <BrandLoader size={84} />
        </div>
    );
};

export default GlobalLoader;
